import { Button } from "../../components";
import { Typography } from "antd";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { successModal } from "../../state/action";
import Logo from "../../assets/logo.png";

import SuccessImg from "../../assets/success.JPG";

const { Title } = Typography;

const SuccessCard = ({page}) => {
  const dispatch = useDispatch();
  return (
    <div>
      <div className="flex lg:hidden justify-center">
        <img src={Logo} />
      </div>
      <div className="flex justify-center">
        <img src={SuccessImg} className="" />
      </div>
      <Title level={2}>Successful</Title>
      <p className="text-xl">Enjoy Your Sport Experience</p>
      <div>
        {page ? <Link to="/home">
          <Button
            type="primary"
            className="mt-20 button-quad"
            title="Continue"
            style={{ width: "auto", borderRadius: "5px",padding: "0 50px"}}
          /></Link> :  <Button
          type="primary"
          className="mt-20 button-quad"
          title="Continue"
          onClick={() => dispatch(successModal())}
          style={{ width: "auto", borderRadius: "5px",padding: "0 50px"}}
        />}
      </div>
    </div>
  );
};

export default SuccessCard;
